// extracted by mini-css-extract-plugin
export default {"box":"ManagerLoginBtn_box__eGTvB","btn":"ManagerLoginBtn_btn__E8285","small":"ManagerLoginBtn_small__b2CJj","text":"ManagerLoginBtn_text__0hVdu"};